import { useSyncExternalStore } from 'react';

const MOBILE_QUERY = '(max-width: 768px)';
const TOUCH_QUERY = '(hover: none)';

function subscribe(query: string) {
  return (callback: () => void) => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return () => {};
    }
    const mql = window.matchMedia(query);
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', callback);
      return () => mql.removeEventListener('change', callback);
    }
    // Safari < 14 fallback.
    mql.addListener(callback);
    return () => mql.removeListener(callback);
  };
}

function getSnapshot(query: string): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia(query).matches;
}

// Defaults to `false` during SSR so prerendered HTML matches the
// desktop layout. The hook re-evaluates after hydration via the
// matchMedia listener, mounting any mobile-only components on touch.
function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    subscribe(query),
    () => getSnapshot(query),
    () => false,
  );
}

export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY);
}

export function useIsTouch(): boolean {
  return useMediaQuery(TOUCH_QUERY);
}
